<template>
  <el-dialog
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="addDialogShow"
    :before-close="beforeClose"
    :append-to-body="appendToBody"
    class="small-dialog"
  >
    <el-form :model="formData" :rules="formRule" ref="formRule">
      <el-form-item
        v-for="(item, index) in showItem"
        :label="item.label"
        :key="index"
        :prop="item.prop"
      >
        <el-input
          v-if="item.type === 'input'"
          :readonly="handlerType === 'check'"
          size="small"
          placeholder="请输入"
          v-model="formData[item.prop]"
          :type="item.inputType"
          clearable
        />
        <el-select
          v-else-if="item.type === 'select'"
          :disabled="handlerType === 'check'"
          size="small"
          placeholder="请选择"
          v-model="formData[item.prop]"
          clearable
        >
          <el-option
            v-for="it in dictionary[item.prop]"
            :label="it.label"
            :value="it.value"
            :key="it.value"
          ></el-option>
        </el-select>
        <el-switch v-else v-model="formData[item.prop]" :disabled="handlerType === 'check'">
        </el-switch>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer flex justify-center" v-if="handlerType !== 'check'">
      <el-button type="primary" @click="test" v-if="handlerType !== 'detail'">测 试</el-button>
      <el-button type="primary" @click="submitForm" v-if="handlerType !== 'detail'"
        >保 存</el-button
      >
      <el-button @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { isNil } from 'lodash'
import { assign } from 'lodash'
import { map } from 'lodash'
import { pick } from 'lodash'
import { cloneDeep } from 'lodash'
import { isEmpty } from 'lodash'
import { sortBy } from 'lodash'
import { filter } from 'lodash'

// import { MeasuringPointApi } from '@wiz-api/data-collection'
import MeasuringPointService from '../../../../../services/MeasuringPointService'
// import { isNil, isEmpty, assign, cloneDeep, sortBy, pick, map, filter } from 'lodash'

// const measuringPointApi = new MeasuringPointApi()

export default {
  name: 'com-dialog',
  props: {
    addDialogShow: {
      type: Boolean,
      default: false,
    },
    dataSourceDirectName: {
      // 用于判断四种类型数据源
      type: String,
      default: '',
    },
    dataSourceConfigId: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    measuringPointDetail: {
      // 编辑/查看时的详情信息
      type: Object,
      default: () => {
        return {}
      },
    },
    handlerType: {
      // 用于判断新增/编辑/详情三类
      type: String,
      default: null,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    standardId: {
      type: String,
      default: '',
    },
    folderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showItem: [],
      // 全部基础表单项
      basicItem: [
        {
          id: 1, // 用于筛选是否渲染
          label: '测点编码(kks)', // 表单lable字段
          prop: 'kks', // 表单绑定值名称
          order: 1, // 表单展示顺序
          type: 'input', // 渲染标签类型
          required: true, // 是否必填
          inputType: 'text', // 输入框填充类型
        },
        {
          id: 2,
          label: '名称(itemId)',
          prop: 'pointName',
          order: 2,
          type: 'input',
          required: true,
          inputType: 'text',
        },
        {
          id: 3,
          label: '名称(code)',
          prop: 'pointName',
          order: 2,
          type: 'input',
          required: true,
          inputType: 'text',
        },
        {
          id: 4,
          label: '名称(display name)',
          prop: 'pointName',
          order: 2,
          type: 'input',
          required: true,
          inputType: 'text',
        },
        {
          id: 5,
          label: '地址',
          prop: 'address',
          order: 3,
          type: 'input',
          required: true,
          inputType: 'number',
        },
        {
          id: 6,
          label: '测点类型',
          prop: 'pointType',
          order: 4,
          type: 'select',
          required: true,
        },
        {
          id: 7,
          label: '测点描述',
          prop: 'pointDescription',
          order: 5,
          type: 'input',
          required: false,
          inputType: 'text',
        },
        {
          id: 8,
          label: '单位',
          prop: 'unit',
          order: 6,
          type: 'input',
          required: false,
          inputType: 'text',
        },
        {
          id: 9,
          label: '机组',
          prop: 'machineSet',
          order: 7,
          type: 'input',
          required: false,
          inputType: 'text',
        },
        {
          id: 10,
          label: '功能码',
          prop: 'funCode',
          order: 8,
          type: 'select',
          required: true,
        },
        {
          id: 11,
          label: '地址',
          prop: 'address',
          order: 8,
          type: 'input',
          required: true,
          inputType: 'number',
        },
        {
          id: 12,
          label: '数据类型',
          prop: 'dataType',
          order: 9,
          type: 'select',
          required: true,
        },
        {
          id: 13,
          label: '单点召唤周期',
          prop: 'interrogationCycle',
          order: 9,
          type: 'input',
          required: false,
          inputType: 'number',
        },
        {
          id: 14,
          label: '单点召唤',
          prop: 'generalInterrogationCycle',
          order: 10,
          type: 'switch',
          required: false,
        },
        {
          id: 15,
          label: '类型标识',
          prop: 'funCode',
          order: 10,
          type: 'select',
          required: false,
        },
      ],
      dictionary: {
        // 测点类型
        pointType: [
          {
            label: '开关量(整型)',
            value: 0,
          },
          {
            label: '模拟量(浮点型)',
            value: 1,
          },
        ],
        // 功能码
        funCode: [
          // {
          //   label: '0x03',
          //   value: 0x03,
          // },
          // {
          //   label: '0x04',
          //   value: 0x04,
          // },
          // {
          //   label: '0x01',
          //   value: 0x01,
          // },
          // {
          //   label: '0x02',
          //   value: 0x02,
          // },
        ],
        // 类型标识
        funCode2: [
          {
            label: '120(累计量)',
            value: 120,
          },
          {
            label: '121(增量)',
            value: 121,
          },
        ],
        // 数据类型
        dataType: [
          // {
          //   value: 1,
          //   label: '16位 有符号数',
          // },
          // {
          //   value: 2,
          //   label: '16位 无符号数',
          // },
          // {
          //   value: 3,
          //   label: '16位 按位读写',
          // },
          // {
          //   value: 4,
          //   label: ' 32位 有符号数',
          // },
          // {
          //   value: 5,
          //   label: ' 32位 无符号数',
          // },
          // {
          //   value: 6,
          //   label: '32位 浮点型数',
          // },
          // {
          //   value: 7,
          //   label: ' 64位 浮点型数',
          // },
          // {
          //   value: 8,
          //   label: ' 16位 BCD码',
          // },
          // {
          //   value: 9,
          //   label: ' 32位 BCD码',
          // },
          // {
          //   value: 10,
          //   label: '  96位 BCD码',
          // },
        ],
      },
      daItem: [],
      uaItem: [],
      modbusItem: [],
      iecItem: [],
      formData: {
        kks: null,
        itemid: null,
        address: 0,
        pointType: 1,
        pointName: null,
        unit: null,
        machineSet: null,
        funCode: 0x03,
        funCode2: 120,
        dataType: null,
        interrogationCycle: 0,
        generalInterrogationCycle: 0,
      },
      formRule: {
        kks: [{ required: true, message: '该项为必填', trigger: 'blur' }],
        itemid: [{ required: true, message: '该项为必填', trigger: 'blur' }],
        pointType: [{ required: true, message: '请选择测点类型', trigger: 'change' }],
        address: [{ required: true, message: '该项为必填', trigger: 'blur' }],
        funCode: [{ required: true, message: '该项为必填', trigger: 'blur' }],
        dataType: [{ required: true, message: '该项为必填', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.getDialogType(this.dataSourceDirectName)
    // if (this.handlerType === 'binding') {
    //   this.formData = assign(this.formData, this.measuringPointDetail)
    //   return
    // }
    // if (!isNil(this.measuringPointDetail) && !isEmpty(this.measuringPointDetail)) {
    //   this.measuringPointDetail.generalInterrogationCycle = isNil(this.measuringPointDetail.generalInterrogationCycle)
    //     ? this.measuringPointDetail.generalInterrogationCycle
    //     : Boolean(this.measuringPointDetail.generalInterrogationCycle)
    //   // this.formData = assign(this.formData, this.measuringPointDetail)
    //   this.formData = this.measuringPointDetail
    // }
    this.getFunCode()
    this.getDataType()
    if (this.handlerType == 'detail' || this.handlerType == 'edit') {
      this.getDetail(this.measuringPointDetail.id)
    } else if (this.handlerType == 'binding') {
      this.formData = this.measuringPointDetail
    }
  },
  methods: {
    /**
     * @description: 区分新增、编辑、详情各四类弹窗内容
     * @param {string} sourceName 数据源类别
     * @return {*}
     */
    getDialogType(sourceName) {
      const dataSourceCollection = {
        'opc-da': [1, 2, 6, 7, 8, 9],
        'opc-ua': [1, 4, 6, 7, 8, 9],
        modbus: [1, 3, 5, 6, 7, 8, 9, 10, 12],
        iec104: [1, 3, 6, 7, 8, 9, 11, 13, 14],
        iec102: [1, 3, 6, 7, 8, 9, 11, 15],
        pidb: [1, 4, 6, 7, 8, 9],
        snmp: [1, 4, 6, 7, 8, 9],
      }
      const filterList = filter(this.basicItem, (item) => {
        return dataSourceCollection[sourceName].includes(item.id)
      })
      this.showItem = sortBy(filterList, 'order')
    },
    beforeClose() {
      this.closeDialog()
    },
    cancel() {
      this.closeDialog()
    },
    closeDialog() {
      this.formData = this.$options.data().formData
      this.$emit('addDialogClose')
    },
    refreshList() {
      this.$emit('refreshList')
    },
    async test() {
      if (!this.formData.kks) {
        this.$message.warning('请输入测点编码（kks）')
        return
      }
      const res = await MeasuringPointService.testPoint({
        kks: this.formData.kks,
      })
      if (res && res.code == 0) {
        this.$message.success(res.msg)
      }
    },
    submitForm() {
      // eslint-disable-next-line
      this.$refs.formRule.validate(async (valid) => {
        if (valid) {
          const param = cloneDeep(this.formData)
          param.interrogationCycle = isNil(param.interrogationCycle)
            ? param.interrogationCycle
            : Number(param.interrogationCycle)
          if (this.dataSourceDirectName === 'iec102') {
            this.funCode = this.funCode2
          }
          param.address = isNil(param.address) ? param.address : Number(param.address)
          // eslint-disable-next-line
          param.generalInterrogationCycle = isNil(param.generalInterrogationCycle)
            ? param.generalInterrogationCycle
            : param.generalInterrogationCycle
            ? 0
            : 1
          let query = null
          if (this.handlerType === 'add') {
            const elementCol = map(this.showItem, 'prop')
            query = pick(param, elementCol)
            const res = await MeasuringPointService.addPoint({
              ...query,
              dataSourceConfigId: this.dataSourceConfigId,
              standardId: this.standardId,
              folderId: this.folderId,
            })
            if (res && res.code == 0) {
              this.refreshList()
              this.closeDialog()
              this.$message.success('保存成功')
            }
          } else if (this.handlerType === 'edit') {
            const elementCol = map(this.showItem, 'prop')
            query = {
              ...pick(param, elementCol),
              id: this.formData.id,
              standardId: this.formData.standardId,
              dataSourceConfigId: this.formData.dataSourceConfigId,
              folderId: this.formData.folderId,
            }
            const res = await MeasuringPointService.updatePoint({
              ...query,
            })
            if (res && res.code == 0) {
              this.refreshList()
              this.closeDialog()
              this.$message.success('保存成功')
            }
          } else if (this.handlerType == 'binding') {
            const elementCol = map(this.showItem, 'prop')
            query = {
              ...pick(param, elementCol),
              id: this.formData.id,
            }
            this.$emit('binding', {
              ...query,
              id: this.formData.id,
            })
            this.closeDialog()
          }
        } else {
          this.$message.error('必填项不能为空')
        }
      })
    },
    async getFunCode() {
      if (this.dataSourceDirectName === 'iec102') {
        const res = await MeasuringPointService.getIce102FunCode()
        if (res && res.code == 0) {
          this.dictionary.funCode = res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        }
      } else if (this.dataSourceDirectName === 'modbus') {
        const res = await MeasuringPointService.getModbusFunCode()
        if (res && res.code == 0) {
          this.dictionary.funCode = res.data.map((item) => ({
            label: item.name,
            value: item.id,
          }))
        }
      }
    },
    async getDataType() {
      const res = await MeasuringPointService.getModbusDataType()
      if (res && res.code == 0) {
        this.dictionary.dataType = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      }
    },
    async getDetail(id) {
      const res = await MeasuringPointService.pointDetail(id)
      if (res && res.code == 0) {
        this.formData = {
          ...res.data,
          generalInterrogationCycle: isNil(res.data.generalInterrogationCycle)
            ? res.data.generalInterrogationCycle
            : Boolean(res.data.generalInterrogationCycle),
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
